/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Mukul's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Mukul Rawat Portfolio",
    type: "website",
    url: "./",
  },
};

//Home Page
const greeting = {
  title: "Mukul Rawat",
  logo_name: "MukulRawat",
  subTitle:
    "Hello! I am a passionate Data scientist,  I thrive to build to build data driven solution to increase efficiency of the system and implement action oriented solution to complex buisness problem ",
  resumeLink:
    "https://drive.google.com/file/d/1_c37szx5ToQmWqzh97EhwTtfN32MYlKk/view",
  portfolio_repository: "./",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/mukul1em",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mukul-rawat/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  
  {
    name: "Gmail",
    link: "mailto:mukulrt1997@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  }
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Natural Language processing, Computer Vision, Timeseries Forecasting and Machine learning",
        "⚡ Delivered Solution to use cases like object detection and tracking, Named Entity Recogniton, Recommendation Systems, Speech emotion detection and others",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    // //{
    //   title: "Full Stack Development",
    //   fileName: "FullStackImg",
    //   skills: [
    //     "⚡ Building resposive website front end using React-Redux",
    //     "⚡ Developing mobile applications using Flutter, React Native and solo android apps using Kotlin",
    //     "⚡ Creating application backend in Node, Express & Flask",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "HTML5",
    //       fontAwesomeClassname: "simple-icons:html5",
    //       style: {
    //         color: "#E34F26",
    //       },
    //     },
    //     {
    //       skillName: "CSS3",
    //       fontAwesomeClassname: "fa-css3",
    //       style: {
    //         color: "#1572B6",
    //       },
    //     },
    //     {
    //       skillName: "Sass",
    //       fontAwesomeClassname: "simple-icons:sass",
    //       style: {
    //         color: "#CC6699",
    //       },
    //     },
    //     {
    //       skillName: "JavaScript",
    //       fontAwesomeClassname: "simple-icons:javascript",
    //       style: {
    //         backgroundColor: "#000000",
    //         color: "#F7DF1E",
    //       },
    //     },
    //     {
    //       skillName: "ReactJS",
    //       fontAwesomeClassname: "simple-icons:react",
    //       style: {
    //         color: "#61DAFB",
    //       },
    //     },
    //     {
    //       skillName: "NodeJS",
    //       fontAwesomeClassname: "simple-icons:node-dot-js",
    //       style: {
    //         color: "#339933",
    //       },
    //     },
    //     {
    //       skillName: "NPM",
    //       fontAwesomeClassname: "simple-icons:npm",
    //       style: {
    //         color: "#CB3837",
    //       },
    //     },
    //     {
    //       skillName: "Yarn",
    //       fontAwesomeClassname: "simple-icons:yarn",
    //       style: {
    //         color: "#2C8EBB",
    //       },
    //     },
    //     {
    //       skillName: "Gatsby",
    //       fontAwesomeClassname: "simple-icons:gatsby",
    //       style: {
    //         color: "#663399",
    //       },
    //     },
    //     {
    //       skillName: "Flutter",
    //       fontAwesomeClassname: "simple-icons:flutter",
    //       style: {
    //         color: "#02569B",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Cloud and Deployment",
      fileName: "CloudInfraImg",
      skills: [
        "⚡  Experience with Amazon Web Services offerings like Sagemaker, EC2, S3, RDS, Glue",
        "⚡ Designing end-to-end pipeline for models and providing endpoint them using Streamlit, Flask and Dockerizing applications.",
        "⚡ Performing ETL Pyspark Jobs on Databases",
      ],
      softwareSkills: [
        
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        
        
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/mukulrt1997",
    },
    
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/mukulem",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://leetcode.com/mukulrt1997/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Northeastern University",
      subtitle: "M.S. in Machine Learning, Computer Vision And Algorithms",
      logo_path: "neu.png",
      alt_name: "IIITDM Kurnool",
      duration: "2021 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms.",
        "⚡ Apart from this, I have done courses on Machine Learning.",
        
      ],
      website_link: "https://www.northeastern.edu/",
    },
    {
      title: "Vellore Institue of Technology",
      subtitle: "B.tech in Electronics and Instrumentation",
      logo_path: "vit.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied basics and intermediate of Artificial Intelligence, Machine learning and computer vision.",
        "⚡ Apart from this, I have done courses on Statistics,Optimization algorithms and Image Processing. ",
        "⚡ I worked as Research Assitant for 2 years in the domain of Machine learning and Deep Learning.",
        "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college.",
      ],
      website_link: "https://vit.ac.in/",
    }
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Natural Language Processing With Tensorflow",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://coursera.org/share/c4144494ce40eed50bbd95f2db99f2d4",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    
    {
      title: "Machine Learning with Python",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://coursera.org/share/af44d88755c9bad45a2806074a052744",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    }
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Research",
  description:
    "I have worked with evolving startups as ML and DL Developer. I have also worked with well established companies mostly as a Data Science Intern. Based on my professional experiences, I have realised the value of customer-centric approach, timely deliverables, ethicalness and open-source community.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Machine Learning Engineer",
          company: "Diatoz Solutions PVT LTD.",
          company_url: "",
          logo_path: "diatoz.png",
          duration: "June 2020 - April 2021",
          location: "Bengaluru, India",
          description:
            "I have worked on automating Traffic data Analytics Software as a Service. The projects involve automation for counting, tracking and analysing the traffic flow and for significantly enhancing the profits by building smart mobility solutions using state of the art Machine learning and Deep learning models. I have developed Custom vehicle detection and tracking algorithms using YOLOv5 and DeepSort which gives tracking and count analyis of vechicles and then used time series model to forecast and predict traffic flow.",
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Data Science Research Intern",
          company: "Scientia Infocom.",
          company_url: "",
          logo_path: "sc.png",
          duration: "May 2019 - Sept 2019",
          location: "Bengaluru, India",
          description:
            "I have worked on project to build a prototype web application to automate the evaluation system for descriptive answers in online examinations. I have Developed two different models for lexical similarity using TfIDF and Siamese RNN for semantic similarity using Embeddings in keras",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Artificial Neural Network in Tensorflow 2.0 (Apress Publications)",
          company: "Apress(Springer)",
          company_url: "",
          logo_path: "appress.png",
          duration: "Jan 2020 - May 2020",
          location: "Bengaluru, India",
          description:
            "Contributed in the development of the 'Artificial Neural Network in Tensorflow 2.0'. I have worked on total 8 chapters covering various Computer vision, Natural Language Processing Models such as Seq2seq, Attention Models, Transformers, ResNet etc   ",
          color: "#4285F4",
        },
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest machine learning tools for developing and interpreting models. My best experience is to create models, infer them using various visualization tools and deploy them to web applications.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "mukulrawat.png",
    description:
      " I am available via Linkedin and Mail and will get back to you as soon as possible. I can help you with Machine Learning, Data Analysis, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "http://education.abcom.com/a-simple-technique-for-inflating-an-image-dataset/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Unit 8 , 59 Burbank street, Boston, MA, 02115",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/s62g85enQUsDjJRk7",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 8573186412",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
